import React, { useState, useEffect } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { Input } from './ui/Input';

interface DeleteObraModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (password: string) => void | Promise<void>;
  obraName: string;
  isLoading?: boolean;
  errorMessage?: string | null;
}

export const DeleteObraModal: React.FC<DeleteObraModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  obraName,
  isLoading = false,
  errorMessage = null,
}) => {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (isOpen) {
      setPassword('');
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!password.trim() || isLoading) return;
    onConfirm(password.trim());
  };

  return (
    <Modal isOpen={isOpen} onClose={isLoading ? () => {} : onClose} title="Confirmar Exclusão" size="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="text-sm text-red-400 bg-red-900/50 p-3 rounded-md border border-red-500/50">
          <strong className="block mb-1 text-red-300">Atenção! Ação Irreversível!</strong>
          Você está prestes a excluir permanentemente a obra{' '}
          <strong className="text-white">"{obraName}"</strong>.
          <br />
          Todos os lançamentos de custos associados a esta obra também serão apagados.
        </p>

        {errorMessage && (
          <div className="p-3 bg-red-900/60 border border-red-500 text-red-200 text-sm rounded-md flex items-center space-x-2">
            <span className="font-bold">⚠️</span>
            <span>{errorMessage}</span>
          </div>
        )}

        <p className="text-sm text-dark-text-secondary">
          Para confirmar esta ação, por favor, digite sua senha de administrador abaixo.
        </p>
        <Input
          id="delete-confirm-password"
          label="Sua Senha"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoFocus
          disabled={isLoading}
        />
        <div className="flex justify-end space-x-3 pt-4 border-t border-dark-tertiary mt-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="danger"
            disabled={!password || isLoading}
            isLoading={isLoading}
          >
            {isLoading ? 'Excluindo...' : 'Excluir Permanentemente'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};